// GENERATED by scripts/gen-tokens.mjs from paper-tokens.json and kit-extras.json. Do not edit.
// Paper file 01M4FYB3C5K8TNDCVFPPHYZCJG, page 01 Components & guidelines (Kit 17/18/19).

export const tokens = {
  color: {
    "surface-page": "#FFFFFF",
    "surface-card": "#FFFFFF",
    "surface-raised": "#F5F7F7",
    "fill-secondary": "#ECEFEF",
    ink: "#151C1C",
    "text-body": "#151C1C",
    "text-muted": "#5C6B6B",
    "text-faint": "#799193",
    "border-subtle": "#D7E0E1",
    "border-strong": "#BDCACB",
    primary: "#314041",
    link: "#4D5F60",
    honey: "#E7A226",
    "honey-light": "#E7C08A",
    reward: "#5E3E00",
    "reward-bg": "#FEECD3",
    "notice-bg": "#EAF0F0",
    alert: "#B94734",
    "alert-bg": "#FFF4F2",
    shell: "#151C1C",
    "shell-soft": "#2A3232",
    "shell-hover": "#314041",
    "shell-text": "#BDCACB",
    "shell-faint": "#9CAFB0",
    "on-primary": "#FFFFFF",
    "button-primary-bg": "var(--color-primary)",
    "button-primary-fg": "var(--color-on-primary)",
    "button-secondary-bg": "var(--color-fill-secondary)",
    "button-secondary-fg": "var(--color-ink)",
    "button-tertiary-fg": "var(--color-ink)",
    "button-alert-bg": "var(--color-alert)",
    "input-bg": "var(--color-surface-card)",
    "input-border": "var(--color-border-strong)",
    "input-fg": "var(--color-ink)",
    "card-bg": "var(--color-surface-card)",
    "overlay-bg": "var(--color-surface-card)",
    "page-bg": "var(--color-surface-raised)",
    "pill-live-bg": "var(--color-reward-bg)",
    "pill-live-fg": "var(--color-reward)",
    "pill-live-border": "var(--color-honey-light)",
    "pill-neutral-bg": "var(--color-fill-secondary)",
    "pill-neutral-fg": "var(--color-text-muted)",
    "tick-bg": "var(--color-honey)",
    "tick-fg": "var(--color-ink)",
    "chart-1": "var(--color-primary)",
    "chart-2": "var(--color-honey)",
    "chart-3": "var(--color-border-strong)",
    "chart-track": "var(--color-fill-secondary)",
    "row-rule": "var(--color-border-subtle)",
    "input-placeholder": "var(--color-text-faint)",
    brand: "var(--color-honey)",
    "brand-tint": "var(--color-reward-bg)",
    "on-brand": "var(--color-ink)",
    "chip-bg": "var(--color-notice-bg)",
    "brand-line": "var(--color-honey-light)",
    "focus-ring": "var(--color-primary)",
    "switch-on": "var(--color-primary)",
    "switch-off": "var(--color-border-strong)",
    "switch-knob": "var(--color-surface-card)",
    "selected-day": "var(--color-honey)",
    scrim: "#151C1C66",
    merchant: "#8C2F39",
    "on-merchant": "#FFFFFF",
    "on-merchant-muted": "#FFFFFFB3",
    "on-merchant-track": "#FFFFFF33",
    "button-primary-hover": "#26302F",
    "button-secondary-hover": "#DFE4E4",
    "button-secondary-pressed": "#D3DADA",
    "button-alert-hover": "#A23E2D",
    "focus-soft": "#3140412E",
  },
  fontFamily: {
    sans: "Inter",
    text: "Literata",
    display: "Bricolage Grotesque",
    mono: "Fira Mono",
  },
  fontSize: {
    eyebrow: "12px",
    control: "14px",
    value: "16px",
    "card-title": "18px",
    section: "20px",
    "dialog-title": "24px",
    title: "32px",
    figure: "40px",
    help: "13px",
    "figure-sm": "28px",
  },
  fontWeight: {
    regular: "400",
    medium: "500",
    semibold: "600",
    bold: "700",
  },
  letterSpacing: {
    title: "-0.02em",
    eyebrow: "0.08em",
  },
  lineHeight: {
    eyebrow: "16px",
    control: "20px",
    value: "24px",
    section: "28px",
    title: "40px",
    figure: "48px",
    help: "18px",
    "card-title": "24px",
    dialog: "30px",
    "figure-sm": "34px",
  },
  spacing: {
    "1": "4px",
    "2": "8px",
    "3": "12px",
    "4": "16px",
    "6": "24px",
    "8": "32px",
    "12": "48px",
    "16": "64px",
    "control-sm": "32px",
    control: "40px",
    "control-touch": "44px",
    "button-height": "var(--spacing-control)",
    "button-height-sm": "var(--spacing-control-sm)",
    "button-height-touch": "var(--spacing-control-touch)",
    "button-x": "var(--spacing-4)",
    "card-padding": "var(--spacing-6)",
    "0-5": "2px",
    "1-5": "6px",
    "icon-gap": "var(--spacing-1-5)",
    "input-x": "var(--spacing-3)",
    "pill-x": "var(--spacing-2)",
    "pill-height": "22px",
    choice: "18px",
    "badge-height": "18px",
  },
  radius: {
    cell: "6px",
    control: "8px",
    card: "14px",
    overlay: "20px",
    pill: "999px",
    button: "var(--radius-control)",
    input: "var(--radius-control)",
    tab: "var(--radius-control)",
    surface: "var(--radius-card)",
    dialog: "var(--radius-overlay)",
    badge: "var(--radius-pill)",
    checkbox: "4px",
  },
  container: {
    "field-sm": "96px",
    field: "160px",
    dialog: "560px",
    filter: "200px",
    prose: "620px",
  },
  shadow: {
    card: "0 1px 2px rgba(21,28,28,0.06), 0 4px 12px rgba(21,28,28,0.05)",
    overlay: "0 2px 6px rgba(21,28,28,0.08), 0 12px 32px rgba(21,28,28,0.12)",
    focus: "0 0 0 2px var(--color-surface-card), 0 0 0 4px var(--color-focus-ring)",
    "input-focus": "0 0 0 3px var(--color-focus-soft)",
  },
  motion: {
    duration: {
      fast: 150,
      base: 250,
      slow: [600, 700],
    },
    easing: "cubic-bezier(0.2, 0, 0, 1)",
    reducedMotion: "end-state",
    description: "Kit 19 rules 2 and 4: fast 150 ms (hover, recolour), base 250 ms (tabs, toasts), slow 600-700 ms (counters, gauges). Reduced motion shows the end state at once.",
  },
  typeRoles: {
    eyebrow: {
      family: "sans",
      size: "eyebrow",
      leading: "eyebrow",
      weight: "medium",
      tracking: "eyebrow",
      note: "Eyebrow caps and pill text.",
    },
    control: {
      family: "sans",
      size: "control",
      leading: "control",
      weight: "medium",
      note: "Buttons, labels, tabs, menus, row names.",
    },
    value: {
      family: "sans",
      size: "value",
      leading: "value",
      weight: "regular",
      note: "Inputs, values, sentences; tabular figures.",
    },
    help: {
      family: "sans",
      size: "help",
      leading: "help",
      weight: "regular",
      note: "Help text, hints, meta, dates.",
    },
    "card-title": {
      family: "display",
      size: "card-title",
      leading: "card-title",
      weight: "bold",
      note: "Smallest title.",
    },
    section: {
      family: "display",
      size: "section",
      leading: "section",
      weight: "bold",
      note: "Card and section heads.",
    },
    "dialog-title": {
      family: "display",
      size: "dialog-title",
      leading: "dialog",
      weight: "bold",
      note: "Dialog and sheet titles.",
    },
    title: {
      family: "display",
      size: "title",
      leading: "title",
      weight: "bold",
      tracking: "title",
      note: "Page title.",
    },
    "figure-sm": {
      family: "text",
      size: "figure-sm",
      leading: "figure-sm",
      weight: "medium",
      note: "KPI figures, 28px: first size Literata may draw.",
    },
    figure: {
      family: "text",
      size: "figure",
      leading: "figure",
      weight: "medium",
      note: "Headline figures, 40px.",
    },
  },
  ramps: {
    basalt: {
      "50": {
        hex: "#F3F8F8",
        oklch: "oklch(0.9754 0.0053 197.07)",
      },
      "100": {
        hex: "#EAF0F0",
        oklch: "oklch(0.9506 0.0064 197.05)",
      },
      "200": {
        hex: "#D7E0E1",
        oklch: "oklch(0.9001 0.0098 204.91)",
      },
      "300": {
        hex: "#BDCACB",
        oklch: "oklch(0.8293 0.0143 202.43)",
      },
      "400": {
        hex: "#9CAFB0",
        oklch: "oklch(0.7397 0.0212 200.56)",
      },
      "500": {
        hex: "#799193",
        oklch: "oklch(0.6386 0.0274 202.69)",
      },
      "600": {
        hex: "#607778",
        oklch: "oklch(0.5513 0.027 199.67)",
      },
      "700": {
        hex: "#4D5F60",
        oklch: "oklch(0.4709 0.022 200.59)",
      },
      "800": {
        hex: "#314041",
        oklch: "oklch(0.3587 0.0195 201.37)",
      },
      "900": {
        hex: "#2A3232",
        oklch: "oklch(0.3096 0.011 196.6)",
      },
      "950": {
        hex: "#151C1C",
        oklch: "oklch(0.2194 0.0103 196.42)",
      },
    },
    honey: {
      "50": {
        hex: "#FFF5E8",
        oklch: "oklch(0.9744 0.0203 74.66)",
      },
      "100": {
        hex: "#FEECD3",
        oklch: "oklch(0.951 0.0383 76.2)",
      },
      "200": {
        hex: "#F4DAB5",
        oklch: "oklch(0.9006 0.0565 76.58)",
      },
      "300": {
        hex: "#E7C08A",
        oklch: "oklch(0.8294 0.083 75.25)",
      },
      "400": {
        hex: "#E7A226",
        oklch: "oklch(0.7605 0.1499 75.92)",
      },
      "500": {
        hex: "#BA7F07",
        oklch: "oklch(0.6406 0.1331 75.81)",
      },
      "600": {
        hex: "#976602",
        oklch: "oklch(0.5485 0.1147 75.75)",
      },
      "700": {
        hex: "#7A5200",
        oklch: "oklch(0.4707 0.0987 76.33)",
      },
      "800": {
        hex: "#5E3E00",
        oklch: "oklch(0.3909 0.0821 76.03)",
      },
      "900": {
        hex: "#422B05",
        oklch: "oklch(0.3096 0.0607 74.71)",
      },
      "950": {
        hex: "#291D0C",
        oklch: "oklch(0.2409 0.034 74.58)",
      },
    },
    alert: {
      "50": {
        hex: "#FFF4F2",
        oklch: "oklch(0.9752 0.0122 29.87)",
      },
      "100": {
        hex: "#FEE9E5",
        oklch: "oklch(0.9498 0.0236 30.49)",
      },
      "200": {
        hex: "#FED3C9",
        oklch: "oklch(0.9009 0.0505 33.28)",
      },
      "300": {
        hex: "#F9B4A6",
        oklch: "oklch(0.8308 0.0835 31.75)",
      },
      "400": {
        hex: "#EB8E7C",
        oklch: "oklch(0.7399 0.1169 31.76)",
      },
      "500": {
        hex: "#DA624D",
        oklch: "oklch(0.6403 0.1553 31.74)",
      },
      "600": {
        hex: "#B94734",
        oklch: "oklch(0.5493 0.1515 31.73)",
      },
      "700": {
        hex: "#923C2C",
        oklch: "oklch(0.4701 0.1201 32.4)",
      },
      "800": {
        hex: "#6D3024",
        oklch: "oklch(0.39 0.0899 32.67)",
      },
      "900": {
        hex: "#4A241C",
        oklch: "oklch(0.3102 0.0597 33.01)",
      },
      "950": {
        hex: "#2D1915",
        oklch: "oklch(0.2391 0.0333 31.93)",
      },
    },
    mist: {
      "50": {
        hex: "#F5F7F7",
        oklch: "oklch(0.9746 0.0021 197.12)",
      },
      "100": {
        hex: "#ECEFEF",
        oklch: "oklch(0.9498 0.0032 197.1)",
      },
      "200": {
        hex: "#DBDFDF",
        oklch: "oklch(0.9006 0.0043 197.08)",
      },
      "300": {
        hex: "#C3C8CA",
        oklch: "oklch(0.8295 0.0062 223.47)",
      },
      "400": {
        hex: "#A5ACAE",
        oklch: "oklch(0.7394 0.0085 216.64)",
      },
      "500": {
        hex: "#858E90",
        oklch: "oklch(0.64 0.0109 212.53)",
      },
      "600": {
        hex: "#6B7375",
        oklch: "oklch(0.5494 0.0102 214.38)",
      },
      "700": {
        hex: "#565C5E",
        oklch: "oklch(0.4702 0.0082 219.65)",
      },
      "800": {
        hex: "#414647",
        oklch: "oklch(0.3899 0.0068 211.04)",
      },
      "900": {
        hex: "#2E3132",
        oklch: "oklch(0.3106 0.0046 219.62)",
      },
      "950": {
        hex: "#1E2020",
        oklch: "oklch(0.2414 0.003 196.96)",
      },
    },
    tone: {
      "muted-text": {
        hex: "#5C6B6B",
        oklch: "oklch(0.5153 0.0181 196.6)",
      },
    },
  },
  dark: {
    color: {
      "surface-page": "#151C1C",
      "surface-card": "#2A3232",
      "surface-raised": "#1E2020",
      "fill-secondary": "#314041",
      ink: "#F5F7F7",
      "text-body": "#F5F7F7",
      "text-muted": "#BDCACB",
      "text-faint": "#9CAFB0",
      "border-subtle": "#FFFFFF1A",
      "border-strong": "#FFFFFF33",
      primary: "#BDCACB",
      link: "#BDCACB",
      "on-primary": "#151C1C",
      "honey-light": "#976602",
      reward: "#E7C08A",
      "reward-bg": "#422B05",
      "notice-bg": "#314041",
      alert: "#EB8E7C",
      "alert-bg": "#2D1915",
      "button-alert-bg": "#EB8E7C",
      "tick-fg": "#151C1C",
      "on-brand": "#151C1C",
      "button-primary-hover": "#D7E0E1",
      "button-secondary-hover": "#4D5F60",
      "button-secondary-pressed": "#607778",
      "button-alert-hover": "#F9B4A6",
      "focus-soft": "#BDCACB2E",
    },
    shadow: {
      card: "0 1px 2px rgba(0,0,0,0.4), 0 4px 12px rgba(0,0,0,0.3)",
      overlay: "0 2px 6px rgba(0,0,0,0.5), 0 12px 32px rgba(0,0,0,0.45)",
    },
  },
} as const;

export type Tokens = typeof tokens;
export type ColorToken = keyof Tokens["color"];
export type SpacingToken = keyof Tokens["spacing"];
export type RadiusToken = keyof Tokens["radius"];
export type TypeRole = keyof Tokens["typeRoles"];
